// mixins/AgGridContextSplit.js
export default {
  computed: {
    splitGridOptions () {
      if (!this.gridOptions) {
        return {
          gridOptionsExceptContext: {},
          gridOptionsContext: undefined
        }
      }

      const { context, ...rest } = this.gridOptions

      return {
        gridOptionsExceptContext: rest,
        gridOptionsContext: context
      }
    },

    gridOptionsExceptContext () {
      return this.splitGridOptions.gridOptionsExceptContext
    },

    gridOptionsContext () {
      return this.splitGridOptions.gridOptionsContext
    }
  }
}
